import { ReplicationsListFilter } from '../replications.types';

export const REPLICATIONS_UI_ACTION_NAMES = {
  START_NEW_REPLICATION: 'REPLICATIONS_UI_ACTION_NAMES.START_NEW_REPLICATION',
  CANCEL_NEW_REPLICATION: 'REPLICATIONS_UI_ACTION_NAMES.CANCEL_NEW_REPLICATION',
  SET_REPLICATIONS_LIST_FILTER:
    'REPLICATIONS_UI_ACTION_NAMES.SET_REPLICATIONS_LIST_FILTER',
  START_EDIT_REPLICATION: 'REPLICATIONS_UI_ACTION_NAMES.START_EDIT_REPLICATION',
  CANCEL_EDIT_REPLICATION:
    'REPLICATIONS_UI_ACTION_NAMES.CANCEL_EDIT_REPLICATION',

  SELECT_REPLICATION: 'REPLICATIONS_UI_ACTION_NAMES.SELECT_REPLICATION',
  HIDE_VERSION_DETAILS: 'REPLICATIONS_UI_ACTION_NAMES.HIDE_VERSION_DETAILS',
};

export const startNewReplication = () => ({
  type: REPLICATIONS_UI_ACTION_NAMES.START_NEW_REPLICATION,
  payload: undefined,
});

export const cancelNewReplication = () => ({
  type: REPLICATIONS_UI_ACTION_NAMES.CANCEL_NEW_REPLICATION,
  payload: undefined,
});

export const setReplicationsListFilter = (filter: ReplicationsListFilter) => ({
  type: REPLICATIONS_UI_ACTION_NAMES.SET_REPLICATIONS_LIST_FILTER,
  payload: filter,
});

export const selectReplication = (replicationId: string) => ({
  type: REPLICATIONS_UI_ACTION_NAMES.SELECT_REPLICATION,
  payload: replicationId,
});

export const hideVersionDetails = () => ({
  type: REPLICATIONS_UI_ACTION_NAMES.HIDE_VERSION_DETAILS,
  payload: undefined,
});

export const startEditReplication = (replicationId: string) => ({
  type: REPLICATIONS_UI_ACTION_NAMES.START_EDIT_REPLICATION,
  payload: replicationId,
});

export const cancelEditReplication = () => ({
  type: REPLICATIONS_UI_ACTION_NAMES.CANCEL_EDIT_REPLICATION,
  payload: undefined,
});
